module.exports = __webpack_public_path__ + "static/img/proImg2.e45c94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg2.png
// module id = Mjb7
// module chunks = 1